/* eslint-disable */
// @ts-nocheck

// documentation : https://react-select.com/styles#styles

const autoCompleteInputStyle = {
  container: (provided: any, state: any) => ({
    ...provided,
    width: '100%',
    // backgroundColor: 'blue',
  }),

  control: (provided: any, state: any) => ({
    ...provided,
    // width: '100%',
    borderColor: 'var(--chakra-colors-secondaryColor) !important',

    // borderBottom: '1px dotted pink',
    borderRadius: '12px',
    boxShadow: '0 0 0 1px var(--chakra-colors-secondaryColor)',
  }),

  menu: (provided: any, state: any) => ({
    ...provided,
    // width: state.selectProps.width,
    borderBottom: '1px dotted pink',
    color: state.selectProps.menuColor,
    // padding: 20,
  }),
  input: (provided: any, state: any) => ({
    ...provided,
    fontFamily: 'Primary Regular',
    width: '100%',
    height: '50px',
    lineHeight: '50px',
    padding: '2px 12px',

    // width: '80%',
    // borderRadius: '20px',
    // borderBottom: '1px dotted pink',
  }),
  placeholder: (provided: any, state: any) => ({
    ...provided,
    fontFamily: 'Primary Regular',
    height: '50px',
    lineHeight: '50px',
    padding: '2px 12px',

    // width: '80%',
    // borderRadius: '20px',
    // borderBottom: '1px dotted pink',
  }),

  singleValue: (provided: any, state: any) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return {
      ...provided,
      opacity,
      transition,
      fontFamily: 'Primary Regular',
      height: '50px',
      lineHeight: '50px',
      padding: '2px 12px',
    };
  },

  dropdownIndicator: (provided, state) => ({
    display: 'none',
  }),
};

export default autoCompleteInputStyle;
